module.exports = __webpack_public_path__ + "img/vet_introduction.4005c912.jpg";